import React from 'react'
import { Divider, BodyText } from '@paypalcorp/pp-react'
import PropTypes from 'prop-types'
import cssModules from 'react-css-modules'
import { getI18n } from 'client/i18n'
import styles from './activity.less'
import {
  CompletedActivityList,
  PendingContributionsList,
} from 'components/contributions_list/owner_activity_list'
import ActivityRow from 'components/contributions_list/rows/activity_row'

const i18n = getI18n('components/edit_glimpse/activity')

class CrowdfundingActivity extends React.Component {
  static propTypes = {
    campaignId: PropTypes.string,
  }

  render() {
    return (
      <div>
        <BodyText strong>{i18n('crowdfunding_activity.title')}</BodyText>
        <Divider styleName="crowdfunding_activity_divider" />
        <div styleName="list-container">
          <PendingContributionsList
            title={i18n('activity.pending')}
            hideEmpty={true}
            showDaysRows={true}
            txnsPerPage={5}
            campaignId={this.props.campaignId}
            rowElement={(activityItem, key) => (
              <ActivityRow {...activityItem} key={key} />
            )}
          />
        </div>
        <div styleName="list-container">
          <CompletedActivityList
            title={i18n('activity.completed')}
            hideEmpty={true}
            showDaysRows={true}
            txnsPerPage={5}
            campaignId={this.props.campaignId}
            rowElement={(activityItem, key) => (
              <ActivityRow {...activityItem} key={key} />
            )}
          />
        </div>
      </div>
    )
  }
}

export default cssModules(CrowdfundingActivity, styles, {
  allowMultiple: true,
})
